var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2237 10.1131C12.0512 9.89752 11.7366 9.86256 11.521 10.0351L10.6667 10.7185V8.4255C10.6667 8.14935 10.4428 7.9255 10.1667 7.9255C9.89052 7.9255 9.66667 8.14935 9.66667 8.4255V10.7185L8.81233 10.0351C8.5967 9.86256 8.28205 9.89752 8.10955 10.1131C7.93704 10.3288 7.972 10.6434 8.18763 10.8159L9.8525 12.1478C9.93835 12.2172 10.0477 12.2588 10.1667 12.2588C10.2867 12.2588 10.3969 12.2165 10.483 12.146L12.1457 10.8159C12.3613 10.6434 12.3963 10.3288 12.2237 10.1131Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80692 6.61474C8.43534 5.64372 9.52848 5 10.7727 5C12.6485 5 14.1827 6.463 14.2963 8.31021C14.3337 8.30879 14.3713 8.30807 14.4091 8.30807C16.0241 8.30807 17.3333 9.6173 17.3333 11.2323C17.3333 12.8473 16.0241 14.1566 14.4091 14.1566L6.83333 14.1566C4.71624 14.1566 3 12.4403 3 10.3232C3 8.20613 4.71624 6.48989 6.83333 6.48989C7.16927 6.48989 7.49565 6.53322 7.80692 6.61474ZM10.7727 6C9.76935 6 8.9014 6.58399 8.49204 7.43284C8.37867 7.66791 8.10358 7.77626 7.86036 7.68162C7.5426 7.55797 7.19651 7.48989 6.83333 7.48989C5.26853 7.48989 4 8.75841 4 10.3232C4 11.888 5.26853 13.1566 6.83333 13.1566L14.4085 13.1566C15.4712 13.1566 16.3333 12.295 16.3333 11.2323C16.3333 10.1696 15.4718 9.30807 14.4091 9.30807C14.2361 9.30807 14.0693 9.33076 13.9109 9.37305C13.7508 9.41582 13.5799 9.37645 13.4546 9.26794C13.3293 9.15942 13.2659 8.99587 13.2854 8.83126C13.297 8.73276 13.303 8.63234 13.303 8.5303C13.303 7.13286 12.1702 6 10.7727 6Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDownload);
export default __webpack_public_path__ + "static/media/Cloud-download.6fdba42bfc3600d58e55048ffa258a16.svg";
export { ForwardRef as ReactComponent };